import { render, staticRenderFns } from "./DefineDestinationModal.vue?vue&type=template&id=5365b660&scoped=true&"
import script from "./DefineDestinationModal.vue?vue&type=script&lang=js&"
export * from "./DefineDestinationModal.vue?vue&type=script&lang=js&"
import style0 from "./DefineDestinationModal.vue?vue&type=style&index=0&id=5365b660&prod&lang=css&"
import style1 from "./DefineDestinationModal.vue?vue&type=style&index=1&id=5365b660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365b660",
  null
  
)

export default component.exports